import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';
import styles from './carousel-nav-pagination-component.module.scss';

type CarouselNavPaginationProps = {
  slidesCount: number;
  className: string;
};

export const CarouselNavPagination: FunctionComponent<CarouselNavPaginationProps> = ({ slidesCount, className = '' }) => {
  const swiper = useSwiper();

  const [slideConfig, setSlideConfig] = useState({
    activeSlide: 0,
  });

  useEffect(() => {
    const handleSlideChange = () => {
      setSlideConfig({ activeSlide: swiper.activeIndex });
    };

    swiper.on('slideChange', handleSlideChange);
    return () => {
      swiper.off('slideChange', handleSlideChange);
    };
  }, [swiper]);

  return (
    <div className={`${styles.dots} ${className}`}>
      {Array.from({ length: slidesCount }).map((_, i) => (
        <div
          key={i}
          onClick={(e) => {
            e.preventDefault();
            swiper.slideTo(i);
          }}
          className={`${styles.dot} ${slideConfig.activeSlide === i ? styles['dot-selected'] : ''}`}></div>
      ))}
    </div>
  );
};

export default CarouselNavPagination;
